import React from 'react';
import Preloader from '../components/Miscellaneous/Preloader';
import Header from '../components/Header/Header';
import LeadershipDetails from '../components/Experiences/LeadershipDetails';
import CTA from '../components/CTA/CTAOne';
import Footer from '../components/Footer/Footer';
import SearchModal from '../components/Miscellaneous/SearchModal';
import OffcanvasMenu from '../components/Miscellaneous/OffcanvasMenu';
import MagicCursor from '../components/Miscellaneous/MagicCursor';
import LenisScroll from '../components/Header/LenisScroll';

const LeadershipSingle = () => {
    return (
        <div>
            <MagicCursor />
            <Preloader />
            <LenisScroll />
            <div className="main">
                <Header />
                <div id="main-wrapper" className="main-wrapper">
                    <LeadershipDetails />
                    <CTA />
                    <Footer />
                    <SearchModal />
                    <OffcanvasMenu />
                </div>
            </div>
        </div>
    );
};

export default LeadershipSingle;
